import { forwardRef, Ref, type SVGProps } from 'react';

const SvgTooltipArrowIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 16 8"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="m0 0 8 8 8-8Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgTooltipArrowIcon);
export default ForwardRef;
